import { ENDPOINTS, useActions } from 'hammock';
import { nanoid } from 'nanoid';
import { useState } from 'react';

export const useHandleSegementSetUpload = () => {
  const [setId] = useState(nanoid(6));

  const { action } = useActions(ENDPOINTS.segmentsDefinition);

  const onChunk = async (chunk: string[]) => {
    return action({
      name: 'addSetItems',
      query: { setId },
      body: chunk,
    });
  };

  return {
    setId,
    onChunk,
  };
};
